import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import serviceapi from '@/api/api'
import { VueCookies } from 'vue-cookies'

import './assets/css/fonts.css'; // 导入字体样式

const app = createApp(App)

app.use(ElementPlus, {
  locale: zhCn
})
app.use(store)
app.use(router)

app.config.globalProperties.$axios = serviceapi
app.config.globalProperties.$cookies = VueCookies

app.mount('#app')
